/* eslint-disable max-len */
import React from 'react'
import { isDefined } from 'ts-extras'
import { Bulb } from '~/components/Icons'
import type { Product } from '~/types'
import { range } from '~/utils'

interface Props {
	product: Product
}

export const FunFacts: React.FC<Props> = ({ product }) => {
	const facts = extractFunFacts(product)

	return facts.length > 0 ? (
		<div className="text-2xl">
			<h3 className="text-3xl">Fun facts</h3>
			<ul className="list space-y-4">
				{facts.map((fact, i) => (
					<li key={i} className="flex items-start">
						<img src={Bulb} className="mb-4 mr-6 mt-2 h-12 shrink-0 align-middle" />
						<p>{fact}</p>
					</li>
				))}
			</ul>
		</div>
	) : null
}

function extractFunFacts(product: Product): string[] {
	return range(1, 3)
		.map(i => product[`fun_fact_${i}` as 'fun_fact_1']?.value)
		.filter(isDefined)
}
